export default __webpack_public_path__ + "static/media/Dell U2713HM 27.421bb1b9.png";